module.exports = __webpack_public_path__ + "static/media/Slice1.57452e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_174/img/Slice1.png
// module id = 1604
// module chunks = 0